import { TourAnchor } from '../anchors';
import type { TourDefinition } from '../types';

/**
 * Taboo Terra on /ai — linked from the beta launch announcement
 * (`redirect: /ai?tour=ai`). Anchors sit on the composer, the suggestions
 * (centred grid on desktop, row above the composer on phones — two AI_CHIPS
 * mounts, the engine spotlights the visible one), the Guide pill in the composer toolbar, and the Chats sidebar (header when expanded, "Chats" rail item when collapsed; card-only
 * on mobile, where the sidebar is a sheet). The mini player only exists after
 * an answer, so its step is card-only. v2: history moved from the pill drawer
 * to the Chats sidebar. Also auto-starts on the first /ai visit.
 */
export const AI_TOUR = {
  id: 'ai',
  version: 2,
  slug: 'ai',
  path: '/ai',
  autoStart: true,
  name: 'Taboo Terra',
  summary: 'Ask anything, build a travel guide and pick up past chats.',
  steps: [
    {
      id: 'composer',
      anchor: TourAnchor.AI_COMPOSER,
      title: 'Ask Taboo Terra',
      body: 'Name a place, a creator or a question — answers come from real footage.',
    },
    {
      id: 'chips',
      anchor: TourAnchor.AI_CHIPS,
      title: 'Not sure where to start?',
      body: 'Tap a suggestion to see what it can do.',
    },
    {
      id: 'guide',
      anchor: TourAnchor.AI_GUIDE,
      title: 'Build a travel guide',
      body: 'Turn on Guide mode for a day-by-day plan built from our videos.',
    },
    {
      id: 'history',
      anchor: TourAnchor.AI_HISTORY,
      title: 'Pick up where you left off',
      body: 'Your chats live here — search, rename or delete them.',
    },
    {
      id: 'player',
      title: 'Watch without leaving',
      body: 'Videos in answers play right here in a mini player.',
    },
  ],
} as const satisfies TourDefinition;
